import React from 'react';
import ReceiptItem from 'components/common/receipt/receipt_item';
import CaTaxReceiptItem from 'components/common/receipt/ca_tax_receipt_item';
import { getCountryCode } from 'utilities/locales';

/**
 * Note: this file should only be used when showing FULL tax on a receipt. If you need only
 * taxes on shipping and/or items only, use CustomTaxReceiptItem.
 */
const TaxReceiptItem = ({ orderData }) => {
  if (getCountryCode() === 'ca' && orderData.tax_breakdown.length > 0) {
    return <CaTaxReceiptItem orderData={orderData} />;
  }

  if (orderData.additional_tax) {
    return (
      <ReceiptItem
        label={orderData.additional_tax.label}
        cost={orderData.additional_tax.amount}
        currency={orderData.additional_tax.currency}
        isTax={true}
      />
    );
  }

  if (orderData.included_tax) {
    return (
      <ReceiptItem
        label={orderData.included_tax.label}
        cost={orderData.included_tax.amount}
        currency={orderData.included_tax.currency}
        isTax={true}
      />
    );
  }

  if (orderData.total.amount === '0.0' || orderData.zero_tax_rate) {
    return (
      <ReceiptItem
        label="checkout.receipt.label.tax"
        cost={0}
        currency={orderData.total.currency}
        isTax={true}
      />
    );
  }

  return (
    <ReceiptItem
      label="checkout.receipt.label.tax"
      override="checkout.shipping.cost.toBeCalculated"
    />
  );
};

export default TaxReceiptItem;
